import { useEffect } from "react";

import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useAuthContext } from "@main/context/Auth/Auth.context";

import { identifyFullStoryUser } from "../util/fullstoryUtils";

export const useFullStoryIdentify = () => {
  const { userData } = useAuthContext();
  const { selectedWorkspace } = useAppSelectionContext();

  useEffect(() => {
    if (!userData || !selectedWorkspace) return;
    identifyFullStoryUser(userData, selectedWorkspace);
  }, [selectedWorkspace, userData]);
};
